import {Pill} from '@hm/fundamental'
import {mdiLayersOutline} from '@mdi/js'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

export const VersionPill = ({version, value}: {version: number; value: string}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <Pill
      size="large"
      type="primary"
      text={`${t('label.version')} ${version}: ${value}`}
      labelIcon={mdiLayersOutline}
    />
  )
}
